import { render, staticRenderFns } from "./reshippingRequest.vue?vue&type=template&id=69ccdfec&scoped=true"
import script from "./reshippingRequest.vue?vue&type=script&lang=js"
export * from "./reshippingRequest.vue?vue&type=script&lang=js"
import style0 from "./reshippingRequest.vue?vue&type=style&index=0&id=69ccdfec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ccdfec",
  null
  
)

export default component.exports